import { _XSRF } from './global.js'

// 用state换Code
export async function GetCodeUrl (
  axios,
  aState
) {
  var idata = {
    state: aState,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/GetCodeUrl', idata)
  return res
}

// 得到wxRes
export async function GetWXRes (
  axios,
  url
) {
  var idata = {
    url: url,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/GetWXRes', idata)
  return res
}

// 查询父类地址信息
export async function QueryShengShiQuStreetInfo (axios, aType, aParentID) {
  var idata = {
    // 1 ：查询 省 信息
    // 2 : 查询 市 信息
    // 3 ：查询 区 信息
    // 4 ：查询 街道 信息
    Type: aType,
    ParentID: aParentID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QueryShengShiQuStreetInfo', idata)
  return res
}

// 添加一个新的用户收货地址
export async function AddUserDeliveryAddress (
  axios,
  aUserID,
  aConsignee,
  aDeliveryNameTel,
  aDeliveryAddressSheng,
  aDeliveryAddressShi,
  aDeliveryAddressQu,
  aDeliveryAddressStreet,
  aDeliveryAddressDetails,
  aIsDefaultAddress
) {
  var idata = {
    UserID: aUserID,
    Consignee: aConsignee,
    DeliveryNameTel: aDeliveryNameTel,
    DeliveryAddress_Sheng: aDeliveryAddressSheng,
    DeliveryAddress_Shi: aDeliveryAddressShi,
    DeliveryAddress_Qu: aDeliveryAddressQu,
    DeliveryAddress_Street: aDeliveryAddressStreet,
    DeliveryAddress_Details: aDeliveryAddressDetails,
    IsDefaultAddress: aIsDefaultAddress,
    PostNum: '',
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/AddUserDeliveryAddress', idata)
  return res
}

// 查询用户收货地址
export async function QueryUserDeliveryAddress (axios, aUserID) {
  var idata = {
    UserID: aUserID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QueryUserDeliveryAddress', idata)
  return res
}

// 删除用户收货地址
export async function DeleteUserDeliveryAddress (axios, aDeliveryAddressID) {
  var idata = {
    DeliveryAddress_ID: aDeliveryAddressID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/DeleteUserDeliveryAddress', idata)
  return res
}

// 余额支付待支付订单
export async function SuepluePayShoppingOrder (
  axios,
  aUserID,
  aJinEr,
  aOrderID
) {
  var idata = {
    UserID: aUserID,
    JinEr: aJinEr,
    OrderID: aOrderID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/SuepluePayShoppingOrder', idata)
  return res
}

// 更新用户信息
export async function GetUserInfo (
  axios,
  aUserID
) {
  var idata = {
    UserID: aUserID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/GetUserInfo', idata)
  return res
}

// 修改一个用户收货地址
export async function ModifyUserDeliveryAddress (
  axios,
  aUserID,
  aDeliveryAddressID,
  aConsignee,
  aDeliveryNameTel,
  aDeliveryAddressSheng,
  aDeliveryAddressShi,
  aDeliveryAddressQu,
  aDeliveryAddressStreet,
  aDeliveryAddressDetails,
  aIsDefaultAddress
) {
  var idata = {
    UserID: aUserID,
    DeliveryAddressID: aDeliveryAddressID,
    Consignee: aConsignee,
    DeliveryNameTel: aDeliveryNameTel,
    DeliveryAddress_Sheng: aDeliveryAddressSheng,
    DeliveryAddress_Shi: aDeliveryAddressShi,
    DeliveryAddress_Qu: aDeliveryAddressQu,
    DeliveryAddress_Street: aDeliveryAddressStreet,
    DeliveryAddress_Details: aDeliveryAddressDetails,
    IsDefaultAddress: aIsDefaultAddress,
    PostNum: '',
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/ModifyUserDeliveryAddress', idata)
  return res
}

// 查询购物订单
export async function QueryUserShoppingOrder (axios, aUserID, aQueryType) {
  var idata = {
    UserID: aUserID,
    QueryType: aQueryType,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QueryUserShoppingOrder', idata)
  return res
}

// 查询下线的购物订单
export async function QuerySubUserShoppingOrder (axios, aPUserID) {
  var idata = {
    PUserID: aPUserID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QuerySubUserShoppingOrder', idata)
  return res
}

// 从数据库提购物车数据
export async function QueryOrderPayStatus (axios, aUserID, aOrderNo) {
  var idata = {
    UserID: aUserID,
    OrderNo: aOrderNo,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QueryOrderPayStatus', idata)
  return res
}

// 从数据库提购物车数据
export async function QueryShopCart (axios, aUserID, aUserGradeID) {
  var idata = {
    UserID: aUserID,
    UserGradID: aUserGradeID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/QueryUserShopCart', idata)
  return res
}

// 保存购物车数据
export async function SaveShopCart (axios, aUserID, aGoodsItem) {
  // 从数据库提购物车数据
  var idata = {
    UserID: aUserID,
    GoodsItem: aGoodsItem,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/SaveUserShopCart', idata)
  return res
}

// 删除用户购物车数据
export async function DeleteShopCart (axios, aUserID, aGoodsID, aCount) {
  // 从数据库提购物车数据
  var idata = {
    UserID: aUserID,
    GoodsID: aGoodsID,
    Count: aCount,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/DeleteUserShopCart', idata)
  return res
}

// 用户取消购物订单
export async function UserCancelShoppingOrder (axios, aOrderID) {
  var idata = {
    OrderID: aOrderID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/UserCancelShoppingOrder', idata)
  return res
}

export async function UserConfirmReceiptShoppingOrder (axios, aOrderID) {
  var idata = {
    OrderID: aOrderID,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/UserConfirmReceiptShoppingOrder', idata)
  return res
}

// 用户取消购物订单
export async function KuaiDiNiaoQueryApi (axios, aLogisticCode, aShipperCode) {
  var idata = {
    LogisticCode: aLogisticCode,
    ShipperCode: aShipperCode,
    _xsrf: _XSRF
  }
  let res = await axios.post('/api/v1.0/KuaiDiNiaoQueryApi', idata)
  return res
}

// 检查金额是否有效
export function IsValidJinEr (JinEr) {
  if (
    Number(JinEr) === 0 ||
    JinEr === null ||
    String(JinEr) === '' ||
    isNaN(Number(JinEr))
  ) {
    return false
  } else {
    var sJinEr = String(JinEr)
    var i = sJinEr.indexOf('.')
    var l = sJinEr.length
    if (i < 0) {
      return true // 是整数
    } else if (l - i <= 3) {
      return true // 大于 0.01
    } else {
      return false // 小于 0.01
    }
  }
}

// 是微信浏览器？
export function isWeiXin () {
  var ua = window.navigator.userAgent.toLowerCase()
  return !!/micromessenger/.test(ua)
}

// 是PC端的 windows 或MACOS？
export function isPC () {
  var u = window.navigator.userAgent
  return !u.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

// 判断当前用户的终端类型 , 采用哪种支付方式
export function TypeTerminal () {
  let isWX = isWeiXin()
  let xiPC = isPC()

  if (isWX && xiPC) {
    return 'NATIVE' // windows 或 MacOS 端的微信，采用扫码支付方式
  } else {
    return 'JSAPI'
  }
}

// 得到随机数
export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

// 得到URL中的参数， 返回参数数据
export function GetUrlParam (paraName) {
  var url = document.location.toString()
  var arrObj = url.split('?')
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&')
    var arr
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr != null && arr[0] === paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils.js